export const PM_LINK = 'pmLink';
export const PM_FORMATTING = 'pmFormatting';
export const PM_CHANGE_COLOR = 'pmChangeColor';
export const PM_PAYMENT = 'pmPayment';
export const PM_EMOJI_POPOVER = 'pmOpenEmojiPopover';
export const PM_EMOJI = 'pmInsertEmoji';
export const PM_INVOICE = 'pmInvoice';
export const PM_REPLY_HISTORY = 'pmReplyHistory';